import type { ComponentProps } from 'react'

import { ICON_DEFAULT_COLOR, ICON_DEFAULT_FILL, type IconProps } from 'components'

export const Copy = ({
  color = ICON_DEFAULT_COLOR,
  fill = ICON_DEFAULT_FILL,
  width = '24', // TODO: Replace with ICON_DEFAULT_WIDTH when migration to ION is complete
  height = '24', // TODO: Replace with ICON_DEFAULT_HEIGHT when migration to ION is complete
  viewBox = '0 0 24 24', // TODO: Replace with ICON_DEFAULT_VIEWBOX when migration to ION is complete
  ...props
}: ComponentProps<'svg'> & Omit<IconProps, 'icon'>) => {
  return (
    <svg
      fill={fill}
      height={height}
      viewBox={viewBox}
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M21.25 10C21.25 9.30964 20.6904 8.75 20 8.75H10C9.30964 8.75 8.75 9.30964 8.75 10V20C8.75 20.6904 9.30964 21.25 10 21.25H20C20.6904 21.25 21.25 20.6904 21.25 20V10ZM15.25 4C15.25 3.31421 14.6858 2.75 14 2.75H4C3.31421 2.75 2.75 3.31421 2.75 4V14C2.75 14.6858 3.31421 15.25 4 15.25C4.41421 15.25 4.75 15.5858 4.75 16C4.75 16.4142 4.41421 16.75 4 16.75C2.48579 16.75 1.25 15.5142 1.25 14V4C1.25 2.48579 2.48579 1.25 4 1.25H14C15.5142 1.25 16.75 2.48579 16.75 4C16.75 4.41421 16.4142 4.75 16 4.75C15.5858 4.75 15.25 4.41421 15.25 4ZM22.75 20C22.75 21.5188 21.5188 22.75 20 22.75H10C8.48122 22.75 7.25 21.5188 7.25 20V10C7.25 8.48122 8.48122 7.25 10 7.25H20C21.5188 7.25 22.75 8.48122 22.75 10V20Z"
        fill={color}
      />
    </svg>
  )
}
